import { useEffect } from "react";
import Point from 'ol/geom/Point';
import { toLonLat } from 'ol/proj';
import Circle from 'ol/geom/Circle';

export const useTranslateAndClick = (mapInstance, value, handleChange, translateRef, locationFeatureRef, isDraggingFeature) => {
  useEffect(() => {
    if (!translateRef.current || !locationFeatureRef.current || !mapInstance) return;

    const handleTranslateEnd = (event) => {
      isDraggingFeature.current = false;
      const geometry = locationFeatureRef.current.getGeometry();

      if (geometry instanceof Point) {
        const coordinates = geometry.getCoordinates();
        const [longitude, latitude] = toLonLat(coordinates);
        handleChange({
          latitude,
          longitude,
        })
      } else if (geometry instanceof Circle) {
        const center = geometry.getCenter();
        const [longitude, latitude] = toLonLat(center);
        handleChange({
          latitude,
          longitude,
        })
      }

    };

    const handleMapClick = (event) => {
      const clickedCoordinate = event.coordinate;
      const geometry = locationFeatureRef.current.getGeometry();

      if (geometry instanceof Point) {
        geometry.setCoordinates(clickedCoordinate);
        const [longitude, latitude] = toLonLat(clickedCoordinate);
        handleChange({
          latitude,
          longitude,
        });
      } else if (geometry instanceof Circle) {
        geometry.setCenter(clickedCoordinate);
        const [longitude, latitude] = toLonLat(clickedCoordinate);
        handleChange({
          latitude,
          longitude,
        });
      }
    };

    translateRef.current.on('translateend', handleTranslateEnd);
    mapInstance.on('click', handleMapClick);

    return () => {
      translateRef.current && translateRef.current.un('translateend', handleTranslateEnd);
      mapInstance && mapInstance.un('click', handleMapClick);
    }
  }, [value])

}


// WEBPACK FOOTER //
// ./src/containers/AdFormPage/LocationSelector/hooks/useTranslateAndClick.ts